<template>
  <v-flex class="time-picker-wrapper" xsm2>
    <v-menu
      ref="menu"
      v-model="menu2"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="time"
      lazy
      transition="slide-y-reverse-transition"
      offset-y
      full-width
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field v-model="time" :label="name" prepend-icon="access_time" readonly v-on="on"></v-text-field>
      </template>
      <v-time-picker
        landscape
        header-color="primary"
        v-if="menu2"
        v-model="time"
        full-width
        @click:minute="saveTime()"
      ></v-time-picker>
    </v-menu>
  </v-flex>
</template>

<script>
export default {
  name: "StartEndDatePicker",
  props: {
    name: {
      type: [String],
      default: ""
    },
    menu: {
      type: [Boolean],
      default: false
    },
    time_incoming: {
      type: [String],
      default: "00:00"
    }
  },
  methods: {
    saveTime() {
      this.$refs.menu.save(this.time);
      this.$emit("getTime", this.time);
    }
  },
  data() {
    return {
      time: this.time_incoming,
      menu2: null
    };
  }
};
</script>

<style lang="scss" scoped>

.v-menu__content {
  position: fixed!important;
  min-width: 100%!important;
  left: 0!important;
  bottom: 0px!important;
  top: auto!important;
}

</style>